import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Layers, ArrowRight, ChevronLeft } from "lucide-react";

export default function StudentSubjects() {
  const { courseId } = useParams();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/subjects?course_id=${courseId}`).then((r) => setItems(r.data)); }, [courseId]);
  return (
    <div className="space-y-6" data-testid="student-subjects-page">
      <Link to="/student/courses" className="text-sm text-slate-500 hover:text-slate-900 inline-flex items-center gap-1"><ChevronLeft className="w-4 h-4" />Back to Courses</Link>
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600">Course</div>
        <h1 className="font-display text-3xl font-bold tracking-tight mt-1">Subjects</h1>
      </div>
      <div className="grid grid-cols-1 2xl:grid-cols-3 gap-4">
        {items.length === 0 ? <div className="text-slate-500 col-span-full">No subjects yet.</div> :
          items.map((s) => (
            <Link to={`/student/subjects/${s.id}/modules`} key={s.id} className="block" data-testid={`student-subject-${s.id}`}>
              <Card className="p-6 border-slate-200 hover:shadow-md hover:-translate-y-0.5 transition-all">
                <div className="h-10 w-10 rounded-md bg-blue-50 text-blue-700 grid place-items-center mb-4"><Layers className="w-5 h-5" strokeWidth={1.5} /></div>
                <h3 className="font-display text-lg font-bold break-words">{s.subject_name}</h3>
                <p className="text-sm text-slate-600 mt-1 line-clamp-2 break-words">{s.description}</p>
                <div className="mt-4 text-sm font-semibold text-blue-700 inline-flex items-center gap-1">View Modules <ArrowRight className="w-4 h-4" /></div>
              </Card>
            </Link>
          ))}
      </div>
    </div>
  );
}
